<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
/*.under-rvw-pblsh {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
}*/
.under-rvw-pblsh {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.knowledgebase-icon {
  margin-right: 20px;
}
.knowledgebase-icon a svg {
  width: 30px;
  height: 30px;
}
.disable-preview {
  cursor: no-drop;
  opacity: 0.5;
  background-image: linear-gradient(135deg, #929292, #ccc) !important;
}
.external-link-area,
.external-link-area1 {
  background-image: linear-gradient(135deg, #008aff, #86d472);
  display: inline-flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 10px;
  padding: 3px;
  height: 40px;
  border-radius: 6px;
  box-sizing: border-box;
}
.external-link-area,
.external-link-area1 {
  color: #7b7979;
}
.external-link-area:hover,
.external-link-area1:hover {
  color: #fff;
}
.external-link-area .link-area-span,
.external-link-area1 .link-area-span {
  align-items: center;
  background: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  height: 100%;
  transition: background 0.5s ease;
  width: 100%;
  padding: 0 15px;
}
.link-area-span span {
  display: inline-block;
  line-height: 0;
}
.link-area-span span svg {
  fill: #7b7979;
}
.link-area-span span svg path.cls-1 {
  fill: #7b7979 !important;
}
.external-link-area:hover .link-area-span,
.external-link-area1:hover .link-area-span {
  background: transparent;
}
.external-link-area:hover .link-area-span span svg,
.external-link-area1:hover .link-area-span span svg path.cls-1 {
  fill: #ffffff !important;
}
.external-link-area {
  flex-direction: row !important;
}
.external-link-area1 {
  flex-direction: row;
  position: relative;
}
// .external-link-area1:after {
//   content: "";
//   position: absolute;
//   height: 50%;
//   width: 1px;
//   background: #333;
//   right: 0;
//   top: 50%;
//   transform: translateY(-70%);
// }
.external-link-area .icon-extrnl-link {
  margin-right: 5px;
  color: #000000;
}
.external-link-area .icon-extrnl-link svg {
  height: 21px;
  width: 21px;
}
.external-link-area .title-ico,
.external-link-area1 .title-ico {
  font-size: 14px;
  font-weight: 600;
}
.knowledgebase-icon {
  display: inline-flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}
.title-ico {
  font-size: 12px;
}
.knowledgebase-icon a {
  line-height: 0;
}
.icon-extrnl-link {
  height: 31px;
}

/* ------ review-publish -------- */
/*.under-rvw-pblsh button{width: 105px !important; height: 40px; border-radius: 50px;}
.under-rvw-pblsh .vs-switch--circle {width: 36px; height: 36px; transform: translateY(-50%);  top: 50% !important;}
.under-rvw-pblsh .vs-switch.vs-switch-active .vs-switch--circle {margin-left: calc(100% - 40px) !important;}*/
.swal2-header h2 {
  font-size: 18px !important;
}
.sub-holder {
  color: #aaa9a9;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}
.navbar-alert {
  position: fixed;
  z-index: 99999;
  left: 50%;
  transform: translateX(-50%);
  top: 33px;
}
.navbar-alert .vs-progress--background {
  position: absolute;
  top: 100%;
  left: 0;
}
.navbar-alert .con-vs-alert {
  border-radius: 4px 4px 0 0;
}
.external-link-area img,
.external-link-area1 img {
  height: 20px;
  width: 20px;
}
.external-link-area1 {
  cursor: pointer;
}
.heading-wrap h2,
.h2 {
  font-size: 24.36px !important;
  line-height: inherit !important;
  letter-spacing: inherit !important;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.heading-wrap p {
  font-size: 14px !important;
}
.header-custome h3,
.h3 {
  font-size: 21.14px !important;
}
.vs-button-success {
  font-weight: 700;
}
.registrationType-popup.con-vs-popup .vs-popup {
  width: 1090px !important;
  height: auto;
}
.vs-sidebar-group.vs-sidebar-group-active .group-header {
  background: rgba(76, 138, 246, 0.5) !important;
}
.vs-sidebar-group.vs-sidebar-group-open.vs-sidebar-group-active {
  background: #323c4c;
  padding: 15px 15px 0 15px !important;
}
.vs-sidebar-group.vs-sidebar-group-open.vs-sidebar-group-active
  .feather-grp-header-arrow {
  top: 26px;
}
.vs-sidebar-group.vs-sidebar-group-open span.feather-grp-header-arrow {
  top: 26px !important;
}
.vs-sidebar-group.vs-sidebar-group-open .group-header {
  background: #3f63a1 !important;
}
.vs-sidebar-group.vs-sidebar-group-open {
  background: #323c4c;
  padding: 15px 15px 0 15px !important;
}
.external-link-button{text-decoration: none;}
@media only screen and (min-width: 1367px) and (max-width: 1600px) {
  .header-custome {
    margin-top: 0px;
  }
    .content-area-reduced .external-link-area, .content-area-reduced .external-link-area1{margin-right: 10px; min-width: 128px;}
.content-area-reduced .external-link-area .title-ico, .content-area-reduced .external-link-area1 .title-ico {font-size: 13px; word-break: break-word; line-height: 12px;}
}

@media only screen and (max-width: 1366px) {
  .header-custome {
    margin-top: 0px;
  }
  .content-area-reduced .external-link-area, .content-area-reduced .external-link-area1{margin-right: 10px; min-width: 128px;}
.content-area-reduced .external-link-area .title-ico, .content-area-reduced .external-link-area1 .title-ico {font-size: 13px; word-break: break-word; line-height: 12px;}
}
</style>

<template>
  <div class="relative">
    <div class="navbar-alert">
      <vs-alert :active="ShowProgressBarMsg">
        <span v-html="ProgressbarMessage"></span>
      </vs-alert>
      <vs-progress
        v-show="ShowProgressBar"
        indeterminate
        :percent="ProgressBarPercent"
        color="success"
      >
      </vs-progress>
    </div>
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />
        <div class="heading-wrap" v-if="!$route.path.includes('/event/list')">
          <vx-tooltip
            class="w-full"
            :text="Session_Event_FullName"
            position="bottom"
          >
            <h2>{{ Session_Event_FullName }}</h2>
          </vx-tooltip>

          <vx-tooltip
            class="w-full"
            :text="Session_EventStartDate + ' - ' + Session_EventEndDate +  ' All Dates & times are displayed in ' + Session_Event_TZ + ' timezone '"
            position="bottom"
          >
            <p
            class="sub-holder"
            v-cloak
            v-if="
              Session_Event_FullName != null && Session_EventStartDate != null
            "
          >
            {{ Session_EventStartDate }} - {{ Session_EventEndDate }} (All Dates
            & times are displayed in {{ Session_Event_TZ }} timezone)
          </p>
          </vx-tooltip>
          
        </div>
        <div class="heading-wrap" v-else>
          <h2>{{ Session_Client_Name }}</h2>
        </div>

        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

        <vs-spacer />
        <a class="external-link-button"
          @click="$router.push('/event/overview')"
          v-if="
            Session_Event_FullName != null &&
            !$route.path.includes('/event/list')
          "
        >
          <div class="external-link-area1">
            <!-- <feather-icon
              class="sm:inline-flex cursor-pointer p-0 icon-extrnl-link"
              icon="ExternalLinkIcon"
              title="Preview Website"
            /> -->
            <div class="link-area-span">
              <!-- <img src="../../../assets/overview-top.svg" class="mr-2" /> -->
              <span class="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 40.53 40.531"
                >
                  <defs></defs>
                  <path
                    id="event-overview.svg"
                    class="cls-1"
                    d="M1101,302.992h-10a4,4,0,0,1-4-4v-10a4,4,0,0,1,4-4h10a4,4,0,0,1,4,4v10A4,4,0,0,1,1101,302.992Zm0-12a2,2,0,0,0-2-2h-6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2v-6ZM1095,307a7.994,7.994,0,0,1,6.89,12.058l3.06,3.063a2,2,0,0,1-2.83,2.829l-3.06-3.064A8,8,0,1,1,1095,307Zm0,12.108a4.108,4.108,0,1,0-4.11-4.108A4.109,4.109,0,0,0,1095,319.108Zm-16,5.884h-10a4,4,0,0,1-4-4v-10a4,4,0,0,1,4-4h10a4,4,0,0,1,4,4v10A4,4,0,0,1,1079,324.992Zm0-12a2,2,0,0,0-2-2h-6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2v-6Zm0-10h-10a4,4,0,0,1-4-4v-10a4,4,0,0,1,4-4h10a4,4,0,0,1,4,4v10A4,4,0,0,1,1079,302.992Zm0-12a2,2,0,0,0-2-2h-6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2v-6Z"
                    transform="translate(-1065 -285)"
                  />
                </svg>
              </span>
              <span class="title-ico">Overview</span>
            </div>
          </div>
        </a>

        <a class="external-link-button cursor-pointer"
          v-if="
            CustomDomain != '' &&
            Session_Event_FullName != null &&
            !$route.path.includes('/event/list')
          "          
          @click="createJoinURL"
          id="v-step-start"
        >
          <div
            :class="
              !disablePreviewBtn
                ? 'external-link-area'
                : 'external-link-area disable-preview'
            "
          >
            <!-- <feather-icon
              class="sm:inline-flex cursor-pointer p-0 icon-extrnl-link "
              icon="ExternalLinkIcon"
              title="Preview Website"
            /> -->
            <div class="link-area-span">
              <!-- <img src="../../../assets/external-link.svg" class="mr-2" /> -->
              <span class="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns:svgjs="http://svgjs.com/svgjs"
                  version="1.1"
                  width="20"
                  height="20"
                  x="0"
                  y="0"
                  viewBox="0 0 612 612"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                  class=""
                  fill="#000000"
                  data-original="#000000"
                >
                  <g>
                    <g xmlns="http://www.w3.org/2000/svg">
                      <g id="_x35__35_">
                        <g>
                          <path
                            d="M568.286,524.571c0,23.759-19.978,43.715-43.715,43.715l-438.585,0.721c-23.759,0-42.993-19.256-42.993-42.993     l0.721-438.585c0-23.759,19.978-43.714,43.714-43.714h240.429V0H87.429C39.933,0,0,48.545,0,96.019v429.974     C0,573.51,38.49,612,85.986,612H515.96c47.495,0,96.04-39.933,96.04-87.429V284.143h-43.714V524.571z M589.662,0h-152.52     c-12.393,0.022-21.835,10.032-21.856,21.857c-0.022,11.825,9.464,21.879,21.856,21.857l96.041-0.7L203.424,357.539     c-8.721,8.328-8.721,21.813,0,30.119c8.721,8.328,22.863,8.328,31.583,0L567.63,70.424l0.656,104.434     c-0.022,11.824,9.464,21.879,21.856,21.857c12.394-0.022,21.836-10.033,21.857-21.857V21.311     C612.021,9.486,602.055-0.022,589.662,0z"
                            style=""
                            class=""
                          />
                        </g>
                      </g>
                    </g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                  </g>
                </svg>
              </span>
              <span class="title-ico">Event Preview</span>
            </div>
          </div>
        </a>
        <span id="v-step-end" style="display: none"></span>
        <div>
          <v-tour
            name="myTourStart"
            :steps="steps"
            :options="tourOptions"
            :callbacks="tourCallbacks"
          ></v-tour>
        </div>
        <!--<a href="/pages/knowledge-base" title="Help Center">
          <div class="knowledgebase-icon">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-help-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </span>
            <span class="title-ico" title="Help Center">Help Center</span>
          </div>
          </a>-->
        <!-- <div class="under-rvw-pblsh mr-5 align-right" v-if="Session_Event_Id && UserRole == 2">
          <small class="mr-2"><b>{{IsPublished ? 'Published' : 'Under-Review'}}</b></small>
          <vs-switch v-model="IsPublished" v-on:click="beforeUnPublishConfirmation">
          </vs-switch>
          
        </div> -->
        <i18n />

        <search-bar />

        <cart-drop-down />

        <notification-drop-down />

        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import CartDropDown from "./components/CartDropDown.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import Swal from "sweetalert2";
import moment from "moment-timezone";

import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage";
import "jquery-ui-dist/jquery-ui";
import { bus } from "../../../main";

import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";

var vm;
var cn = ls.getSessionEventCollectionName();
export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      tourOptions: {
        labels: {
          buttonSkip: "Skip",
          buttonPrevious: "Previous",
          buttonNext: "Preview",
        },
      },
      tourCallbacks: {
        onNextStep: this.onTourFinish,
      },
      CustomDomain: "",
      color: "#5a3cc4",
      IsPublished: false,
      Session_Event_FullName: ls.getSessionValueByKey("Session_Event_FullName"),
      Session_EventStartDate: null,
      Session_EventEndDate: null,
      Session_Event_TZ: ls.getSessionValueByKey("Session_Event_TZ"),
      Session_Event_Id: ls.getSessionValueByKey("Session_Event_Id"),
      Session_Event_CollectionName: ls.getSessionValueByKey(
        "Session_Event_CollectionName"
      ),
      Session_Client_Id: ls.getSessionValueByKey("Session_Client_Id"),
      Session_Client_Name: ls.getSessionValueByKey("ClientName"),
      UserRole: ls.getSessionValueByKey("Role"),
      ShowProgressBarMsg: false,
      ShowProgressBar: false,
      ProgressbarMessage: null,
      ProgressBarPercent: 0,
      previewUrl: null,
      redirect_url: "attendees",
      steps: [],
      disablePreviewBtn: false,
    };
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor !== "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
  },
  methods: {
    onTourFinish() {
      vm.steps.pop();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
      let CustomDomain = ls.getSessionValueByKey("CustomDomain");
      window.open(
        `https://${CustomDomain}/joincms/${Session_Client_Id}/${Session_Event_Id}/preview`,
        "_blank"
      );
      bus.$emit("startTour", true);
      this.$router.push("/event/overview/tour").catch(() => {});
    },
    showResponsivePreview() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
      let CustomDomain = ls.getSessionValueByKey("CustomDomain");
      //this.previewUrl = `https://${CustomDomain}/joincms/${Session_Client_Id}/${Session_Event_Id}/preview`;
      this.steps.splice(0, 0, {
        target: "#v-step-start",
        header: { title: "Event Preview" },
        offset: -200,
        params: { placement: "bottom" },
        content:
          "Click on the Event Preview to open the virtual event web view in preview mode",
      });

      this.steps.splice(1, 0, {
        target: "#v-step-end",
        header: { title: "Next" },
        offset: -200,
        params: { placement: "bottom" },
        content: "",
      });

      if (vm.$route.path.includes("overview")) {
        var Session_Event_CollectionName = ls.getSessionValueByKey(
          "Session_Event_CollectionName"
        );

        let Session_EndTime = ls.getSessionValueByKey("Session_EventEndDate");

        if (new Date(Session_EndTime).getTime() >= new Date().getTime()) {
          vm.disablePreviewBtn = false;
        } else {
          vm.disablePreviewBtn = true;
        }

        var eventRef = con.eventDB.collection(cn).doc("EventInfo");
        eventRef.get().then(function (eventDetail) {
          if (eventDetail.data().HasSeenTour == undefined && vm.disablePreviewBtn == false) {
            con.eventDB
              .collection(Session_Event_CollectionName)
              .doc("EventInfo")
              .update({ HasSeenTour: true })
              .then(function () {
                vm.$tours["myTourStart"].start();
              });
          }
        });

        
      }
    },
    Set_Session_Event_FullName() {
      //this.Session_Event_FullName = field.Name
      //this.Session_Event_Id = field.Event_Id
      this.getEventDetail();
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    getEventDetail() {
      (vm.Session_Event_FullName = ls.getSessionValueByKey(
        "Session_Event_FullName"
      )),
        (vm.Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id")),
        (vm.Session_Event_CollectionName = ls.getSessionValueByKey(
          "Session_Event_CollectionName"
        )),
        (vm.Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id"));
      if (vm.Session_Client_Id && vm.Session_Event_Id) {
        con.instanceDB
          .doc("ClientList")
          .collection("Clients")
          .doc(vm.Session_Client_Id)
          .collection("Events")
          .doc(vm.Session_Event_Id)
          .get()
          .then(function (doc) {
            if (doc.exists) {
              vm.IsPublished = doc.data().IsPublished;
              vm.Session_Event_FullName = doc.data().EventFullName;
              vm.Session_EventStartDate = vm.SetTimeByZone(
                new Date(
                  doc.data().EventStartDate.seconds * 1000
                ).toUTCString(),
                doc.data().TimeZone
              );
              vm.Session_EventEndDate = vm.SetTimeByZone(
                new Date(doc.data().EventEndDate.seconds * 1000).toUTCString(),
                doc.data().TimeZone
              );
              vm.Session_Event_TZ = doc.data().TimeZone;
              vm.Session_Event_Id = doc.data().EventId;
              vm.Session_Event_CollectionName = doc.data().EventCollectionName;
              //vm.Session_Client_Id = doc.data().Session_Client_Id
              let info = {
                Is_Event_Published: vm.IsPublished,
              };
              ls.setSessionUserInfo(info);
            }
          });
      }
      /*else
      {
        vm.IsPublished = false
        vm.Session_Event_FullName = null
        vm.Session_Event_Id = null
        vm.Session_Event_CollectionName = null
        vm.Session_Client_Id = null
      }*/
    },
    beforeUnPublishConfirmation() {
      vm = this;
      if (vm.IsPublished == true) {
        const { value: text } = Swal.fire({
          title: "Do you want to Unpublish the event?",
          input: "text",
          inputPlaceholder: "Type 'unpublish' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase() == "unpublish") {
              vm.IsPublished = false;
              this.setEventStatus();
            } else {
              return "Try again! Please type 'unpublish' and hit Submit.";
            }
          },
        }).then(function (result) {
          if (result.dismiss != null) {
            vm.IsPublished = true;
          }
        });
      } else {
        vm.IsPublished = true;
        this.setEventStatus();
        this.getEventDetail();
      }
    },
    setEventStatus() {
      vm = this;
      (vm.Session_Event_FullName = ls.getSessionValueByKey(
        "Session_Event_FullName"
      )),
        (vm.Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id")),
        (vm.Session_Event_CollectionName = ls.getSessionValueByKey(
          "Session_Event_CollectionName"
        )),
        (vm.Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id"));
      vm.$vs.loading();
      var IsPublished = vm.IsPublished;
      con.instanceDB
        .doc("ClientList")
        .collection("Clients")
        .doc(vm.Session_Client_Id)
        .collection("Events")
        .doc(vm.Session_Event_Id)
        .update({ IsPublished: IsPublished })
        .then(function () {
          con.eventDB
            .collection(vm.Session_Event_CollectionName)
            .doc("EventInfo")
            .update({ IsPublished: IsPublished })
            .then(function () {
              vm.$vs.notify({
                color: "success",
                title: "Event",
                text: "Status Changed",
              });
              vm.$vs.loading.close();
            });
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY");
      return date;
    },
    createJoinURL(){
      this.$vs.loading();
      this.$store.dispatch("eventManagement/createJoinURL").then((res) => {
        this.$vs.loading.close();
        if(res){
          //this.previewUrl = res.joinURL +"&redirect_url=/"+ this.redirect_url
          window.open(res , '_blank');
          //window.location.href = res.joinURL +"&redirect_url=/"+ this.redirect_url;
        }
      }).catch(err=>{ console.log(err);this.$vs.loading.close(); });
    }
  },
  mounted() {
    vm = this;
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }    
    vm.Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
    var customDomain = ls.getSessionValueByKey("CustomDomain");
    if (customDomain != null) {
      vm.CustomDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
    } else {
      vm.CustomDomain = "";
    }
    let listenerRef = ls.getSessionValueByKey("ProgressBarListenerLink");
    let ImportRefreshLink = ls.getSessionValueByKey("ImportRefreshLink");
    let ProgressbarMessage = ls.getSessionValueByKey("ProgressbarMessage");
    if (listenerRef) {
      con.eventDB.doc(listenerRef).onSnapshot(function (doc) {
        let total_executed =
          Number(doc.data().Result.Duplicate) +
          Number(doc.data().Result.Success) +
          Number(doc.data().Result.Failed);
        vm.ProgressBarPercent =
          (total_executed / Number(doc.data().Result.Total)) * 100;
        vm.ShowProgressBar = true;
        vm.ProgressbarMessage = `${ProgressbarMessage} is in progress... ${total_executed}/${
          doc.data().Result.Total
        } completed`;
        vm.ShowProgressBarMsg = true;
        if (total_executed == Number(doc.data().Result.Total)) {
          ls.removeSessionValueByKey("ProgressbarMessage");
          ls.removeSessionValueByKey("ProgressBarListenerLink");
          ls.removeSessionValueByKey("ImportRefreshLink");
          vm.ShowProgressBar = false;
          vm.ProgressBarPercent = 0;
          vm.ProgressbarMessage = `${ProgressbarMessage} completed. <a href="javascript:location.href='/event/${ImportRefreshLink}'">View Now</a`;
        }
      });
    }
    this.$root.$on(
      "Set_header_Session_Event_FullName",
      this.Set_Session_Event_FullName
    );
    this.getEventDetail();
    this.showResponsivePreview();
  },
  created() {
    bus.$on("startMainTour", (data) => {
      let Session_EndTime = ls.getSessionValueByKey("Session_EventEndDate");
      if (new Date(Session_EndTime).getTime() >= new Date().getTime()) {
        this.$tours["myTourStart"].start();
      } else {
        bus.$emit("startTour", true);
      }
    });
  },
};
</script>

